import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import payments from './paymentsReducer';
import domiciliationReducer from './domiciliationReducer';
import favoritesRefReducer from './favoritesRefReducer';

export default combineReducers({
  payments,
  domiciliationReducer,
  favoritesRefReducer,
  router: routerReducer
});
